/*
export function someAction (context) {
}
*/
export const toggleSideMenu = ({ commit }) => {
  commit('toggleSideMenu')
}

export const setDisablePullToRefresh = ({ commit }, value) => {
  commit('SET_DISABLE_PULL_TO_REFRESH', value)
}